import React,{ useEffect } from 'react';
import { Grid, Link } from '@material-ui/core';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import './community.css';

function Monks({monk}) {
    return(
        <Grid container style={{ marginBottom: '20px'}} >
            <Grid item xs={3} sm={2} md={1}>
                <Avatar style={{ width:'60px', height:'60px'}} src={monk.avatar?monk.avatar:""} />
            </Grid>
            <Grid item xs={9} sm={8} md={4} style={{ marginTop: '-5px', marginLeft: '20px'}}>
                <Typography variant="h6">{monk.name}<span><img alt="Verified" title="Verified" src="assets/images/verified.png" /></span></Typography>
            </Grid>
        </Grid>
    );
}

function Users({user}) {
    return(
        <Grid container style={{ marginBottom: '20px'}} >
            <Grid item xs={3} sm={2} md={1}>
                <Avatar style={{ width:'60px', height:'60px'}} src={user.avatar?user.avatar:""} />
            </Grid>
            <Grid item xs={9} sm={8} md={4} style={{ marginTop: '-5px', marginLeft: '20px' }}>
                <Typography variant="body1">{user.name}</Typography>
            </Grid>
        </Grid>
    );
}

function TabPanel(props) {
    const { children, value, index } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`community-tabpanel-${index}`}
        aria-labelledby={`community-tab-${index}`}
        className="community-tabpanel"
      >
        {value === index && (
          <div>{children}</div>
        )}
      </div>
    );
}

function Community() {
    const [value, setValue] = React.useState(0);
    const [users, setUsers] = React.useState([]);
    const [monks, setMonks] = React.useState([]);

    useEffect(() => {
        getData()
    },[])

    const getData = () =>{
        fetch(`https://recruitingmonk-v2.azurewebsites.net/users`,{
            headers:{
                'Content-Type':'application/json',
            },
            method:'GET',
            })
            .then(response => {
            if(response.ok) {
                console.log(response)
                return response;
            }
            else {
                var error = new Error("Error " + response.status + ": " + response.statusText);
                error.response = response;
                throw error;
            }
        }).then(response => response.json())
        .then(response => {
            if(response.success){
                setUsers([...users, ...response.users]);
                setMonks([...monks, ...response.monks]);
            }
        })
        .catch(error => {
            console.log(error);
        })
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return(
        <div className="Community" style={{background: '#f2f2f2', paddingBottom:"50px"}}>
            <Tabs value={value} onChange={handleChange} aria-label="community-tabs" className="community-tabs" >
                <Tab label="Members" />
                <Tab label="Monks" />
            </Tabs>

            <TabPanel value={value} index={0}>
                {users.map((user,index) => <Users user={user} key={index} />)}
            </TabPanel>
            <TabPanel value={value} index={1}>
                {monks.map((monk,index) => <Monks monk={monk} key={index} />)}
            </TabPanel>
        </div>
    );
}

export default Community;